var _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.8,
    height: 23.73,
    viewBox: "0 0 22.8 23.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user-assistance22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(13.68 7.8) rotate(28.02)",
    fontSize: 9.5,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,9a5.19,5.19,0,0,1-4.1,1.2l-2.5,1a.6.6,0,0,1-.8-.7l.5-1.7a4.37,4.37,0,0,1-1.4-3.9,4.62,4.62,0,0,1,2.7-3.5A4.81,4.81,0,0,1,18.3,1a4.78,4.78,0,0,1,4.2,5.3A4.79,4.79,0,0,1,21,9Z",
    transform: "translate(-0.55 -0.12)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.4,12.1a4.15,4.15,0,0,1,8.3,0,4.19,4.19,0,0,1-4.1,4.1A4.2,4.2,0,0,1,3.4,12.1Zm1.1,0a3.18,3.18,0,0,0,3.1,3.1,3.18,3.18,0,0,0,3.1-3.1A3.18,3.18,0,0,0,7.6,9,3.18,3.18,0,0,0,4.5,12.1Z",
    transform: "translate(-0.55 -0.12)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,22.9c0-2.5-2.5-4.5-5.6-4.5S2,20.4,2,22.9a.47.47,0,0,1-.5.5.47.47,0,0,1-.5-.5c0-3.1,3-5.6,6.7-5.6s6.7,2.5,6.7,5.6a.47.47,0,0,1-.5.5C13.4,23.4,13.2,23.2,13.2,22.9Z",
    transform: "translate(-0.55 -0.12)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-0.55 -0.12)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-0.55 -0.12)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAssistance);
export default __webpack_public_path__ + "static/media/user-assistance.1aeb1cc9d3fc95c88b9b94bbb9dc03dd.svg";
export { ForwardRef as ReactComponent };